import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import './Layout.css';
import Sidebar from '../sidebar/Sidebar';
import Header from '../header/Header';
import { fetchClients } from '../../store/clientsSlice';
import { fetchUserProfile } from '../../store/userSlice';
import { findRouteByPath } from '../../routesConfig';

function Layout({ children, onLogout }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const accessToken = useSelector((state) => state.auth.access_token);
  const [sidebarOpen, setSidebarOpen] = React.useState(() => (
    typeof window !== 'undefined' ? window.matchMedia('(min-width: 960px)').matches : true
  ));

  const currentRoute = useMemo(() => findRouteByPath(location.pathname), [location.pathname]);

  useEffect(() => {
    dispatch(fetchClients());
  }, [dispatch]);

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchUserProfile());
    }
  }, [accessToken, dispatch]);

  useEffect(() => {
    if (typeof window !== 'undefined' && !window.matchMedia('(min-width: 960px)').matches) {
      setSidebarOpen(false);
    }
  }, [location.pathname]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="workspace-shell">
      {sidebarOpen && <button className="workspace-scrim" onClick={toggleSidebar} aria-label="Close navigation" />}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="workspace-main">
        <Header toggleSidebar={toggleSidebar} onLogout={onLogout} currentRoute={currentRoute} />
        <main className="workspace-content">{children}</main>
      </div>
    </div>
  );
}

export default Layout;
